<div class="image-viewer-header">
  <span class="bt-headline">
    {{ infoText ? infoText + " - " : "" }} {{ selectedImage?.getName() | startCase }}
  </span>
  <button mat-icon-button class="close-dialog-button" [matDialogClose]="">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="insight-image-dialog">
    <div class="insight-images">
      <bt-insight-image [ngStyle]="{ width: '100%', height: '100%' }" [insightImageSrc]="selectedImage" [brightness]="100"></bt-insight-image>

      @if (insightImages && insightImages.length > 1) {
        <button class="left-button icon-button-small" mat-icon-button (click)="selectNextImage(false)">
          <mat-icon>chevron_left</mat-icon>
        </button>

        <button class="right-button icon-button-small" mat-icon-button (click)="selectNextImage(true)">
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
    </div>

    @if (insightImages && insightImages.length > 1) {
      <div class="image-thumbnails">
        @for (image of insightImages; track image; let i = $index) {
          <div class="image-thumbnail" [ngClass]="i === selectedIndex ? 'selected-thumbnail' : ''">
            <bt-insight-image [clickToZoom]="false" fxFlexFill [imageSrc]="image.getImageUrl()" (click)="selectImage(i)"></bt-insight-image>
          </div>
        }
      </div>
    }
  </div>
</mat-dialog-content>
